import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { getSettingRetailerExclusivityAgreements } from "@faire/help-center-utils/settings/getSettingRetailerExclusivityAgreements";
var SettingRetailerExclusivityVisibilityFn = function SettingRetailerExclusivityVisibilityFn(settingIsOn) {
  return function (_context) {
    return Promise.resolve(getSettingRetailerExclusivityAgreements() === settingIsOn);
  };
};
export var SettingRetailerExclusivityIsOn = SettingRetailerExclusivityVisibilityFn(true);